import { Table, Tooltip } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { TicketResponse } from "../helpCenter.service";
import TicketStatusBadge from "./TicketStatusBadge";

type Props = {
  tickets: TicketResponse[];
  loading: boolean;
  onOpenTicket: (ticket: TicketResponse) => void;
  onDeleteTicket: (ticket: TicketResponse) => void;
};

const formatDate = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const TicketTable = ({
  tickets,
  loading,
  onOpenTicket,
  onDeleteTicket,
}: Props) => {
  const { t } = useTranslation("helpCenter");
  const columns = [
    {
      title: t("table.subject"),
      dataIndex: "subject",
      key: "subject",
      render: (value: string | null, record: TicketResponse) => (
        <span className="ticket-subject-cell">
          {value || record.description.slice(0, 60)}
        </span>
      ),
    },
    {
      title: t("table.type"),
      dataIndex: "ticket_type",
      key: "ticket_type",
    },
    {
      title: t("table.status"),
      dataIndex: "status",
      key: "status",
      render: (status: TicketResponse["status"]) => (
        <TicketStatusBadge status={status} />
      ),
    },
    {
      title: t("table.creationDate"),
      dataIndex: "created_at",
      key: "created_at",
      render: (val: string) => formatDate(val),
    },
    {
      title: t("table.submittedBy"),
      dataIndex: "created_by_username",
      key: "created_by_username",
    },
    {
      title: "",
      key: "actions",
      width: 80,
      render: (_: unknown, record: TicketResponse) => (
        <div className="ticket-row-actions">
          <Tooltip title={t("table.viewTicket")}>
            <button
              className="ticket-action-btn"
              onClick={() => onOpenTicket(record)}
            >
              <EyeOutlined />
            </button>
          </Tooltip>
          <Tooltip title={t("table.deleteTicket")}>
            <button
              className="ticket-action-btn ticket-action-delete"
              onClick={() => onDeleteTicket(record)}
            >
              <DeleteOutlined />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={tickets}
      loading={loading}
      pagination={false}
      scroll={{ x: 900 }}
    />
  );
};

export default TicketTable;
